import { AppState } from '~src/bootstrap/redux/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { siteUserRemoveFromIdentityPool } from '~src/userManagement/users/actions/SiteUserMenuActions';
import { ISiteUserInfo } from '~src/userManagement/users/models/ISiteUserInfo';

export const SiteUserRemoveFromIdentityPoolAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserRemoveFromIdentityPool,
  translateName: Messages.identityPools_SiteUserAction_SiteUserRemoveFromIdentityPool,
  isVisible: (_targetItems: ISiteUserInfo[], _state: AppState) => {
    return FeatureFlags.identityPoolsEnabled && _targetItems.length === 1 && _targetItems[0].poolMemberships && _targetItems[0].poolMemberships.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: ISiteUserInfo[], _state: AppState) => {
    return targetItems.length === 1;
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => siteUserRemoveFromIdentityPool(targetItems)
};
